import { ActivityFeed } from './ActivityFeed'
import SpaceSidebar from '../spaces/components/spaceSheet/SpaceSidebar'
import { SpaceSheetProvider } from '../spaces/components/spaceSheet/SpaceSheetContext'

const ActivityFeedWrapper = () => {
  return (
    <SpaceSheetProvider>
      <SpaceSidebar />
      <ActivityFeed />
    </SpaceSheetProvider>
  )
}

export default ActivityFeedWrapper
